import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  margin: var(--spacing-03) 0;
`;

export const CommentRichTextActionBtns: FC<{
  isSaveDisabled: boolean;
  saveComment(): void;
  cancelChanges(): void;
}> = ({ isSaveDisabled, saveComment, cancelChanges }) => (
  <Wrapper>
    <Button
      disabled={isSaveDisabled}
      size="small"
      type="primary"
      onClick={saveComment}
    >
      <FormattedMessage id="save" />
    </Button>
    <Button size="small" type="link" onClick={cancelChanges}>
      <FormattedMessage id="cancel" />
    </Button>
  </Wrapper>
);
